import React from 'react';

/**
 * TwoColumnAuthLayout provides a consistent, full-height, two-column layout
 * for screens like the welcome page or login page.
 * One column is typically for an image, and the other for form content.
 */
function TwoColumnAuthLayout({ ImageComponent, FormComponent }) {
  return (
    <div className="container-fluid h-100">
      <div className="row h-100">
        <ImageComponent />
        <FormComponent />
      </div>
    </div>
  );
}

export default TwoColumnAuthLayout;